import React, { useEffect, useState } from 'react';
import {Platform, Dimensions, Text, View, ScrollView, SafeAreaView, StyleSheet, Button, Alert, FlatList } from 'react-native'
import { useRoute } from '@react-navigation/native';
import { useTailwind } from 'tailwind-rn';
import Constants from 'expo-constants';
import * as ScreenOrientation from 'expo-screen-orientation';
import * as FileSystem from 'expo-file-system';

//Firebase
import { database } from '../database/firebase';
import { collection, doc, getDoc, addDoc, query, orderBy, onSnapshot } from 'firebase/firestore';


//My components
import SituaInfoCard from './cards/SituaInfoCard';
import CuadroTema from './cards/CuadroTema';

//import SwiperImage from './Carousel/SwiperImage'


const videominheight = 400;

const DLSitua = (  ) => {

    const { params: {
        situname,
        codigo,
        location,
        ejes,
        niveles,
        tags,
        version
      }} = useRoute();

    const tailwind = useTailwind();

    const [isLoading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [main, setMain] = useState();

    const jsonDir = FileSystem.documentDirectory  + 'json/';
    const resoucesDir = jsonDir + 'myresources/'


    async function getSituacion() 
    {
        console.log("Database");
        console.log(database);

        console.log("get the data");
        console.log(codigo);
        const docRef = doc(database, "Situaciones", codigo);
        const docSnap = await getDoc(docRef);
        console.log("data is");
        console.log(docSnap);
        console.log(docSnap.data())

        setData(docSnap.data())
    }

    async function ensureDirExists(dirtocheck) 
    {
        const dirInfo = await FileSystem.getInfoAsync(jsonDir);
        console.log("check" + jsonDir + ":");
        console.log(dirInfo);
        if (!dirInfo.exists) {
            console.log("Json directory" + dirtocheck + "doesn't exist, creating...");
            await FileSystem.makeDirectoryAsync(dirtocheck, { intermediates: true });
        }
    }


    async function SaveSitu() 
    {
        console.log("Open Local main JSon")
        
        const fileInfo = await FileSystem.getInfoAsync(jsonDir+"main.json");
        console.log("Main JSON:")
        console.log(fileInfo)
        
        let stringmain = ""

        if (!fileInfo.exists) {
            stringmain = "{}";
        }else
        {
            stringmain = await FileSystem.readAsStringAsync( jsonDir+"main.json",{ encoding: FileSystem.EncodingType.UTF8 } );
        }

        let mainjson = JSON.parse(stringmain);
        console.log( mainjson );
        //console.log( data );
        console.log("Mis recursos:")

        let encontrado = false;

        console.log(data);
        console.log(situname)
        let nombre = JSON.parse(situname)
        console.log(nombre)


        let situacion = {
            "nombre": nombre,
            "codigo" : codigo,
            "version": version,
            "ejes":    ejes,
            "niveles": niveles,
            "etiquetas" : tags,
            "ubicacion" : location
        }

        //console.log(nombre);

        console.log("situacion");
        console.log(situacion);
       //console.log(data);


        for(let i= 0; i < mainjson["misrecursos"].length; i++ )
        {
            if(mainjson["misrecursos"][i]["codigo"] == codigo) 
            {
                encontrado = true;
                console.log("encontrado")
                mainjson["misrecursos"][i]["nombre"] = nombre;
                mainjson["misrecursos"][i]["version"] = codigo;
                mainjson["misrecursos"][i]["ejes"] = ejes;
                mainjson["misrecursos"][i]["niveles"] = niveles;
                mainjson["misrecursos"][i]["etiquetas"] = tags;
                mainjson["misrecursos"][i]["ubicacion"] = location;
            }
        }

        if (encontrado == false)
        {
            mainjson["misrecursos"].push(situacion);
        }

        //mainjson["misrecursos"] = [];

        console.log("main final");
        console.log( mainjson );

        const jsonfile = FileSystem.writeAsStringAsync(
            jsonDir + "main.json", ( JSON.stringify(mainjson) ).toString() ,{ encoding: FileSystem.EncodingType.UTF8 } 
        )
    }


  useEffect(() => {

    getSituacion().then(
        () => ensureDirExists(jsonDir)
    ).then(
        () => ensureDirExists(resoucesDir)
    )
    .then(
        () => SaveSitu()
    ).then(
        () => setLoading(false)
    );
    
  }, []);



  return (
    <ScrollView>
    <SafeAreaView style ={ tailwind("flex justify-center p-8") }>
      <View style={styles.title}><Text>Descargando Situación... </Text></View>
      {isLoading ? <Text>Descargando...</Text> : 
        <View>
            <Text>{data["titulo"]["esp"]}</Text>
        </View>
      }
      
    </SafeAreaView>

    </ScrollView>
  );
};
  
const styles = StyleSheet.create({});
  
export default DLSitua